import e from "@dialpad/dialtone-tokens/layered/themes/tokens-110-colors.css?inline";
//#region themes/110.js
var t = { brand: {
	css: e,
	name: "110"
} };
//#endregion
export { t as default };
